import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'


class Newsletter extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {

    }

  }

  mount() {

   $('#mce-EMAIL').on('click', (e)=>{
    $('.newsletter .newsletter__message').empty()
   })

    $('#newsletter__form').on('submit', (e)=>{
        e.preventDefault()

        console.log('submit');
        const form = $('#newsletter__form')
        const url = form.attr('action')
        const email = form.find('#mce-EMAIL').val()
        const error = $('.newsletter .newsletter__message')
        error.html(``)
        form.addClass('sending')
        $('#newsletter__form').attr('disabled', true)

        this.mailchimp(email, url).done(
          (data) => {

            console.log(data);
            if (data.result != "success") {
                form.addClass('error')
                form.removeClass('sending')
                error.html(`<p>${data.msg}</p>`)
                $('#newsletter__form').attr('disabled', false)

            } else {
                form.addClass('done')
                form.removeClass('sending error')
                form.find('#mce-EMAIL').val('')
                error.html(`<p>${data.msg}</p>`)
                $('#newsletter__form').attr('disabled', false)
            }
        }).fail(
          (err) => {
              form.addClass('error')
              form.removeClass('sending')
              $('#newsletter__form').attr('disabled', false)
          }
        )
    })




  }


  mailchimp(email, url) {

    var data = {
      'EMAIL': email,
      utf8: '✓'
    };

    var promise = $.ajax({
        url: url ,
        method: 'post',
        data: data,
        cache       : false,
        dataType    : 'jsonp',
        jsonp: 'c',
        contentType: "application/json; charset=utf-8"
    })

    return promise;
  }






  unmount() {

    //this.delayedCall.kill()
    // stage.removeListener("stage:resize", this.resizeQue);
    // stage.removeListener("stage:scroll", this.renderQue);

  }


}

module.exports = Newsletter
